import CartService from "./services/cart"
import CartDrawer from "./components/cart-drawer";
import InitProductForms from "./components/init-product-forms";
import QuantityComponents from "./components/quantity-components";
import CartCount from "./components/cart-count";
import InitAddToCartButtons from "./components/init-add-to-cart-buttons";
import InitCarts from "./components/init-carts";
import Customers from './components/customers';
import InitCartAwareProductForms from "./components/init-cart-aware-product-forms";
import InitFreeShippingNotices from "./components/init-free-shipping-notices";
import CartAlert from "./components/cart-alert";

const MXShop = function( options ){
    const defaultOptions = { 
        openOnAdd : true , 
        hasCustomers : true , 
        cartAware : false,
        freeShipping : false ,
        hasCartDrawer : true, 
        cartAlert : false
    };
    options = { ...defaultOptions , ...options };
    Shopify.cartService = CartService();
    Shopify.cartService.init();
    InitProductForms()
    InitAddToCartButtons()
    QuantityComponents()
    InitCarts()
    CartCount('[sh-cart-count]');
    if( options.hasCartDrawer){
        CartDrawer({ openOnAdd: options.openOnAdd } )
    }
    if( options.hasCustomers){
        Customers();    
    }
    if( options.cartAware ){
        InitCartAwareProductForms( options.hasCartDrawer );
    }
    if( options.freeShipping){
        InitFreeShippingNotices();
    }
    if( options.cartAlert){
        CartAlert();
    }


}

export default MXShop
